import { render } from "./Access Denied.vue?vue&type=template&id=71e9cb96"
import script from "./Access Denied.vue?vue&type=script&lang=js"
export * from "./Access Denied.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__